import React from "react";
import { connect } from "react-redux";

// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './statusResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class StatusResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getStatusLogData = () => {

        let sortedArray = this.props.statusLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];


        sortedArray.forEach((entry) => {
            JSX.push(<tr className="StatusResult-value" key={entry.id}>
                <td className="StatusResult-date-value">{entry.insertedon.split('.')[0].replace('T', ' ')}</td>
                <td>{entry.campaignid}</td>
                <td className="StatusResult-description-value">{entry.whathappened}</td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {

        if (this.props.statusLogs) {
            return (<div className="StatusResult">

                <div className="StatusResult-log-details-container">
                    <table className="StatusResult-log-details">
                        <thead>
                            <tr>
                                <th className="StatusResult-date">Date</th>
                                <th className="StatusResult-schedule">CampaignID</th>
                                <th className="StatusResult-description">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getStatusLogData()}
                        </tbody>
                    </table>
                </div>
                <div className="StatusResult-pagination">
                    <div className="StatusResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="StatusResult-pagination-buttongroup">
                        <button className="StatusResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="StatusResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.statusLogs.logs && state.logs.statusLogs.logs.length) {
        //showing 25 entries max per page
        return { statusLogs: state.logs.statusLogs.logs, maxPage: state.logs.statusLogs.logs.length % 25 === 0 ? state.logs.statusLogs.logs.length / 25 : Math.ceil(state.logs.statusLogs.logs.length / 25) };
    } else {
        return { statusLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(StatusResult);
